export default __webpack_public_path__ + "static/media/due_date.96fcdc24.svg";